export default __webpack_public_path__ + "static/media/noun_Dental Implant_2665773.2a916f6d.png";